// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-6.use[1]!../../../../../../node_modules/vue-loader/dist/stylePostLoader.js!../../../../../../node_modules/sass-loader/dist/cjs.js!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./ImageGalleryDesktopSlider.vue?vue&type=style&index=0&id=83f0e318&lang=scss");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("52834487", content, true, {});